import TransactionDetail from "@/controllers/transaction/transaction-detail.js";
import tinycolor from "tinycolor2";

export default {
  extends: TransactionDetail,

  computed: {
    transactionCategoryName() {
      const inout = this.inout ?? {};
      return (
        inout.transactionCategoryName ||
        inout.transaction_category_name ||
        inout.transactionCategory?.category_name ||
        "-"
      );
    },
    transactionCategoryColor() {
      const inout = this.inout ?? {};
      const rawColor =
        inout.transactionCategoryColor ||
        inout.transaction_category_color ||
        inout.transactionCategory?.color_code ||
        "";

      return this.normalizeHexColor(rawColor);
    },
  },

  methods: {
    normalizeHexColor(colorCode) {
      const normalizedColor = String(colorCode ?? "").trim();
      if (!normalizedColor) {
        return "";
      }

      const color = tinycolor(normalizedColor);
      if(color.isValid()) {
        return normalizedColor;
      }

      return "";
    },
  },
};
